export class DesignationMaster {
    public ID: number;
    public DesignationName: string;
    public YearID: number;
}